import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';

export default function ISRCMappingBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    const onClose = () => {
        param.ISRCMappingClose();
    }

    return (
        <div className="ws-6">

            <Modal open={param.param} onClose={onClose} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >
                <div className="box">
                    <div className="box-header-main">
                        <h2 > ISRC Mapping</h2>
                    </div>
                    <div className="box-content">
                        <div className="row-fluid">
                            <form className="form-horizontal form-condensed  row-fluid ng-pristine ng-invalid ng-invalid-required" name="isrcform">
                                <div className="alert alert-success  ng-hide" data-ng-show="showSuccessSaveMsg">ISRC saved successfully
                                </div>

                                <div className="alert alert-danger  ng-hide" ng-show="isrcform.$submitted &amp;&amp; !isrcform.$valid">
                                    There was a problem submitting your request, one or more fields are missing or incorrect.
                                </div>

                                <div className="form-format ws-12 m0">
                                    <label className="control-label ws-2 ">Current ISRC</label>
                                    <div className="label-entries ml">
                                        <div className="ws-4">
                                            <input readOnly name="isrcfield" className="form-control text-uppercase ng-pristine ng-untouched ng-invalid ng-invalid-required" data-ng-className="{requiredFocus:isrcform.$submitted &amp;&amp; isrcform.isrcfield.$invalid}" placeholder="ISRC" data-ng-model="isrcMappingDetails.selectedRecord.repIsrcCode" required/>
                                        </div>
                                        <div className="ws-4">
                                            <button type="button" className="icon-btn primary " ng-click="ISRCMappingSelection(1)">
                                                <i className="icon-qrcode"></i> Choose ISRC
                                            </button>
                                        </div>
                                    </div>
                                    <span data-ng-show="(isrcMappingDetails.selectedRecord.newTrackArtist + isrcMappingDetails.selectedRecord.newTrackTitle).length &gt; 0" className="ws-7 m0 ml  ng-hide"> - </span>
                                </div>


                                <div className="form-format ws-12 m0 mt">
                                    <label className="control-label ws-2 ">ISRC Should Be</label>

                                    <div className="label-entries ml">
                                        <div className="ws-4">
                                            <input readOnly type="text" name="isrcshouldbe" className="form-control text-uppercase ng-pristine ng-untouched ng-invalid ng-invalid-required" data-ng-className="{requiredFocus:isrcform.$submitted &amp;&amp; isrcform.isrcshouldbe.$invalid}" placeholder="ISRC" data-ng-model="isrcMappingDetails.selectedRecord.newIsrcCode"/>
                                        </div>

                                        <div className="ws-4">
                                            <button type="button" className="icon-btn primary " ng-click="ISRCMappingSelection(0)">
                                                <i className="icon-qrcode"></i> Choose ISRC
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <span className="ws-7 m0 ml  ng-hide" ng-show="(isrcMappingDetails.selectedRecord.repTrackArtist + isrcMappingDetails.selectedRecord.repTrackTitle).length &gt; 0"> - </span>


                                <div className="form-format ws-12 m0 mt">
                                    <label className="control-label ">On UPC</label>
                                    <div className="label-entries w-30 ml">
                                        <input type="text" name="onupc"  data-ng-className="{requiredFocus:isrcform.$submitted &amp;&amp; isrcform.onupc.$invalid}" placeholder="UPC" data-ng-model="isrcMappingDetails.selectedRecord.onUpcCode" required/>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                    <div className="box-footer pull-right">
                        <button className="btn icon-btn edit btn-sm " ng-click="isrcform.$submitted=true;isrcMappingDetails.addUpateRecord(isrcform)"><i className="icon-save"></i> Save
                        </button>
                        <button className="btn btn-pink btn-sm " ng-click="isrcMappingDetails.clearSelectedRecord(isrcform)">
                            <i className="icon-reload"></i> Reset
                        </button>
                    </div>

                </div>
            </Modal>

        </div>
    )
}